import { FC } from 'react';

import { Responsive } from 'components/_basic/Responsive';

import { DesktopLayout } from './DesktopLayout';
import { MobileLayout } from './MobileLayout';
import { NotoSansPreload } from './NotoSansPreload';
import { IBusinessPageToolLayoutProps } from './types';

export const BusinessPageToolLayout: FC<IBusinessPageToolLayoutProps> = (props) => {
  return (
    <>
      <NotoSansPreload />
      <Responsive aboveMobile>
        <DesktopLayout {...props} />
      </Responsive>
      <Responsive mobile>
        <MobileLayout {...props} />
      </Responsive>
    </>
  );
};
